export default __webpack_public_path__ + "static/adotcollector-755ba013e9d8eb5b2d2e208ed8bda933.png";